<div class="">
  <h3 class="font-semibold text-gray-800 mb-6 text-center">
    Selecciona el problema que tienes
  </h3>

  <div class="grid gap-3 max-h-96 overflow-y-auto">
    @for(catalogo of catalogos(); track catalogo._id) {
    <button
      [class]="
        selectedProblemData()?._id === catalogo._id
          ? 'w-full p-4 text-left bg-orange-100 border-2 border-orange-500 rounded-lg transition-all duration-200 shadow-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent group'
          : 'w-full p-4 text-left bg-gray-50 hover:bg-orange-50 border border-gray-200 rounded-lg transition-all duration-200 hover:border-orange-300 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent group'
      "
      (click)="selectProblem(catalogo)"
    >
      <div class="flex items-center justify-between">
        <span
          [class]="
            selectedProblemData()?._id === catalogo._id
              ? 'text-orange-800 font-semibold'
              : 'text-gray-700 group-hover:text-orange-700 font-medium'
          "
        >
          {{ catalogo.name }}
        </span>
        @if(selectedProblemData()?._id === catalogo._id) {
        <svg
          class="w-5 h-5 text-orange-600"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        } @else {
        <svg
          class="w-5 h-5 text-gray-400 group-hover:text-orange-500 transition-colors"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          ></path>
        </svg>
        }
      </div>
    </button>
    }
  </div>

  @if(catalogos().length === 0) {
  <div class="text-center py-8">
    <div class="text-gray-400 mb-2">
      <svg
        class="w-12 h-12 mx-auto"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.47-.881-6.08-2.33"
        ></path>
      </svg>
    </div>
    <p class="text-gray-500">No hay problemas disponibles en este momento</p>
  </div>
  }
</div>
